import { CommandType } from "~app/common/services/cqs/CommandType";
import { ArbetsorderHandelssortimentBaseCommand } from "./ArbetsorderHandelssortimentBaseCommand";

export class AddArbetsorderHandelssortimentCommand extends ArbetsorderHandelssortimentBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "AddArbetsorderHandelssortimentCommand";

    constructor(handelssortimentId: number, arbetsorderId: number) {
        super(AddArbetsorderHandelssortimentCommand.$type, CommandType.Insert);
        this.handelssortimentId = handelssortimentId;
        this.arbetsorderId = arbetsorderId;
    }
}
